<style>
  .positioned.relative {
    position: relative;
  }
  .positioned.absolute {
    position: absolute;
  }
  .positioned.fixed {
    position: fixed;
  }
  .positioned.static {
    position: static;
  }
  .positioned.pin-all,
  .positioned.pin-y,
  .positioned.pin-top {
    top: 0;
  }
  .positioned.pin-all,
  .positioned.pin-y,
  .positioned.pin-bottom {
    bottom: 0;
  }

  .positioned.pin-all,
  .positioned.pin-x,
  .positioned.pin-left {
    left: 0;
  }

  .positioned.pin-all,
  .positioned.pin-x,
  .positioned.pin-right {
    right: 0;
  }
</style>

<template>
  <div class="positioned" :class="className">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "Positioned",
    props: ['top', 'bottom', 'left', 'right', 'absolute', 'relative', 'fixed', 'pin-all'],
    computed: {
      className(){
        let clazz = "";
        const props = Object.keys(this.$props).filter(propKey => this.$props[propKey] !== undefined);
        props.forEach(prop => {
          //convert camelCase string to dashed
          var dashedProp = prop.replace(/[A-Z]/g, m => "-" + m.toLowerCase());
          clazz += " " + dashedProp;
        });

        return clazz;
      }
    }
  }
</script>
